export default {
  state: () => ({
    loading: false,
    bookLoading: false,
    notification: {
      isVisible: false,
      message: '',
      color: ''
    },
    innerWidth: 0
  }),

  getters: {
    isMobile (state) {
      return state.innerWidth < 768
    }
  },

  mutations: {
    loading (state, payload) {
      state.loading = payload
    },

    toggleBookLoading (state, payload) {
      state.bookLoading = payload
    },

    setInnerWidth (state, value) {
      state.innerWidth = value
    },

    setNotification (state, payload) {
      state.notification = payload
      setTimeout(() => { state.notification.isVisible = false }, 5000)
    }
  },

  actions: {
    async getGlobalData ({ dispatch, commit }) {
      commit('loading', true)

      return Promise.all([
        dispatch('getPlans'),
        dispatch('getCurrentPlan'),
        dispatch('stats'),
        dispatch('getBooks'),
        dispatch('getSettings'),
        dispatch('getProjects')
      ]).then((res) => {
        return Promise.resolve()
      }).catch((err) => {
        return Promise.reject(err)
      })
    }
  }
}
